import React, { useState, useRef } from "react";

// import components
import DCard from "../../components/DCard";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";
import orderServices from "../../services/orders";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import moment from "moment";
import { orderStatusBtnStyle, statusMessage } from "../../utils/functions";
import { toast } from "react-hot-toast";
import DModal from "../../components/DModal";

// import utils
const ColumnsSearch = [
  { key: "id", value: "الآيدي" },
  { key: "status", value: "حالة الطلب" },
  { key: "user_name", value: "اسم الزبون" },
  { key: "date", value: "التاريخ" },
  { key: "user_username", value: "اسم المستخدم" },
];
const columns = [
  { Header: "رقم الطلب", accessor: "id" },
  { Header: "الرقم المشفر", accessor: "obfuscationId" },
  // { Header: "معرف المنتج", accessor: "subitem_id" },
  { Header: "المنتج الرئيسي", accessor: "product_name" },
  { Header: "المنتج الفرعي", accessor: "name" },
  { Header: "اسم المستخدم", accessor: "username" },
  { Header: "معرف اللاعب", accessor: "playerid" },
  { Header: "السعر", accessor: "total_cost" },
  { Header: "الكمية", accessor: "amount" },
  { Header: "الرصيد قبل الطلب", accessor: "balance_before" },
  { Header: "الرصيد بعد الطلب", accessor: "balance_after" },
  { Header: "المعرف الخارجي", accessor: "external_id" },
  { Header: "نوع المعاملة", accessor: "type" },
  { Header: "تاريخ الطلب", accessor: "created_at" },
  { Header: "ملاحظات", accessor: "note" },
  { Header: "حالة الطلب", accessor: "status" },
  { Header: "التحكم", accessor: "action" },
];
const Index = ({ title }) => {
  const searchRef = useRef();
  const selectRef = useRef();
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("id") || "");
  const [searchParam, setSearchParam] = useState("id"); 
  const handleSelectChange = () => {
    setSearchParam(selectRef.current.value);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
  
      setSearchQuery(""); 
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault(false);
    const select = selectRef.current.value;
    const search = searchRef.current.value;
    if (select === "status") {
      switch (search) {
        case "نجح":
        case "success":
          searchRef.current.value = "success";
          break;
        case "فشل":
        case "failed":
          searchRef.current.value = "failed";
          break;
        case "انتظار":
        case "inprogress":
          searchRef.current.value = "inprogress";
          break;
        default:
          searchRef.current.value = "";
          break;
      }
    }
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
    queryClient.refetchQueries("getUsers");
  };


  ////////////////////////////////////////////////////////////////////
  const [decodedValue, setDecodedValue] = useState("");
  const inputRef = useRef(null);
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(0);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [openModal, setOpenModal] = useState(false);

 

  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery(
    ["totalOrders", currentPage, searchParam, searchQuery],
    () =>
      orderServices.getAllOrdersWithSearch(
        currentPage + 1,
        searchParam,
        searchQuery
      )
  );
  const statusSorrundWithButton = (cell) => {
    return (
      <DButton
        className={`${
          cell.value === "في الانتظار" ? "text-third-color" : "text-white"
        } min-w-[100px] rounded-[50px_!important]`}
        bgColor={orderStatusBtnStyle(cell.value)}
      >
        {cell.render("Cell")}
      </DButton>
    );
  };
  const closeModal = () => {
    setCurrentOrder(null);
    setOpenModal(false);
  };

  const backBalance = () => {
    if (currentOrder) {
      orderServices
        .updateOrderStatus(currentOrder, "failed")
        .then(() => {
          toast.success("تم ارجاع المبلغ بنجاح");
          queryClient.refetchQueries("totalOrders");
          setOpenModal(false);
          setCurrentOrder(null);
        })
        .catch((err) => {
          console.log(err);
          toast.error("فشل ارجاع المبلغ");
        });
    }
  };

  const handleDecode = async () => {
    try {
      const inputValue = inputRef.current.value; 
      const decodedResult = await orderServices.getDeObfuscationId(inputValue);
      setDecodedValue(decodedResult);
    } catch (error) {
      setDecodedValue(null);
      inputRef.current.value = "";
      toast.error("فشلت عملية فك التشفير يرجى التحقق من المدخلات ");
    }
  };

  const formattedData = (data) => {
    if (data) {
      return data.data.data.map((d) => ({
        ...d,
        name: d.subitem.name,
        obfuscationId: d.oid,
        // subitem_id: d.subitem.id,
        external_id: d.external_id ? d.external_id : "لايوجد",
        status: statusMessage(d.status),
        created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
        username: d.user.username,
        product_name: d.subitem.item.name,
        balance_before: d.balance_before ? d.balance_before : "لايوجد",
        balance_after: d.balance_after ? d.balance_after : "لايوجد",
        playerid: d.topup ? d.order_info.player_id : "لايوجد",
        type: d.subitem.api_id ? "آلي" : "يدوي",
        info: (
          <DButton
            className={"min-w-[100px] text-white rounded-[50px_!important]"}
            onClick={() => navigate(`/orders/${d.id}`)}
          >
            عرض
          </DButton>
        ),
        action: (
          <div className="flex flex-col items-center gap-2 justify-center">
            {d.external_id || statusMessage(d.status) === "فشل" ? null : (
              <DButton
                onClick={() => {
                  setOpenModal(true);
                  setCurrentOrder(d.id);
                }}
                className={"min-w-[100px] text-white rounded-[50px_!important]"}
              >
                ارجاع المبلغ
              </DButton>
            )}
            <DButton
              bgColor="secondry"
              className={"min-w-[100px]  rounded-[50px_!important]"}
              onClick={() => navigate(`/orders/${d.id}/note`)}
            >
              ملاحظة
            </DButton>
          </div>
        ),
      }));
    }
    return [];
  };
  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <PageHeading>{title}</PageHeading>

      <DModal
        isOpen={openModal}
        onClose={closeModal}
        modelType="process"
        clickHandler={backBalance}
        bodyText="بمجرد الموافقة سيتم ارجاع المبلغ المطلوب للعميل"
      />

      <DCard className={`${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <>
            <div className="flex lg:flex-row flex-col gap-4 justify-between ">
              <div>
                <form className="flex  max-lg:justify-center   flex-wrap gap-4 " onSubmit={handleSubmit}>
                  <input
                    type="text"
                    ref={searchRef}
                    className="  px-[10px] relative max-lg:py-1 max-lg:w-full  border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                    placeholder="البحث عن  ..."
                  />
                  <select
                    className=" px-[10px] relative  text-gray-700   max-lg:w-full border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                    value={searchParam}
                    ref={selectRef}
                    onChange={handleSelectChange}
                  >
                    {ColumnsSearch.map((d, index) => (
                      <option className="" key={index} value={d.key}>
                        {d.value}
                      </option>
                    ))}
                  </select>
                  <DButton
                    bgColor="success"
                    className=" px-4 max-lg:mb-2  max-lg:w-full     text-white"
                    type="submit"
                  >
                    {" "}
                    بحث
                  </DButton>
                </form>
              </div>
              <div className="flex items-center gap-2 ">
                <input
                  ref={inputRef}
                  className="p-2  ps-[10px] relative  max-lg:w-full border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                  placeholder="ادخل الرقم المشفر"
                />
                <DButton
                  bgColor="primary"
                  onClick={handleDecode}
                  className={" max-lg:w-full text-white "}
                >
                  فك تشفير
                </DButton>
                <div className="ms-2 text-xl font-bold">
                  {decodedValue && <p>{decodedValue}</p>}
                </div>
              </div>
            </div>

            <Table
              head={columns}
              body={formattedData(data)}
              setCurrentPage={setCurrentPage}
              enableSearch={false}
              currentPage={currentPage}
              totalData={data.data.total}
              elements={{ status: statusSorrundWithButton }}
            />
          </>
        )}
      </DCard>
    </div>
  );
};

export default Index;
